import React from 'react';

import { useAppSelector } from 'state/hooks';

import {
  selectRouteSelection,
  selectSegmentId,
} from '../../../state/workflowSlice';
import { RouteInstructionsPanel } from './RouteInstructions';

export function NoRouteSelectedPanel() {
  const segmentId = useAppSelector(selectSegmentId);
  const routeSelection = useAppSelector(selectRouteSelection);
  if (segmentId === undefined && routeSelection === undefined) {
    return <RouteInstructionsPanel />;
  } else {
    return null;
  }
}
